<template>
  <b-modal
    id="memberDocModal"
    modal-class="client-details-modal"
    centered
    size="lg"
    hide-footer
    no-close-on-backdrop
    hide-header-close
    @shown="getData"
  >
    <template #modal-header>
      <div class="view-clients-header">
        <b-button variant="close-btn"  class="btn-container" @click="closeModal">
          <i class="fas fa-times"></i>
        </b-button>
      </div>
    </template>
    <b-container fluid ref="memberDocContainer">
      <div class="view-clients-modal-content">
        <h6 v-if="user">
          {{ user.name }} -
          {{ member && member.policy_id ? member.policy_id : "" }}
        </h6>
        <p class="email-address">{{ user.email }}</p>
        <ul class="client-docs">
          <li v-if="!files">
            <no-content text="No files found." />
          </li>
          <li v-for="(file, index) in filteredFiles" :key="index">
            <div class="d-inline me-2">
              <input type="checkbox" id="checkbox-1"
              name="checkbox-1"
              v-model="form.data"
              :value="file">
            </div>
            <!-- <b-form-checkbox
              id="checkbox-1"
              name="checkbox-1"
              v-model="form.data"
              :value="file"
            /> -->
            <a :href="file.url" target="_blank">{{ file.filename }}</a>
          </li>
        </ul>
        <p class="new-rates" v-if="checkPlan()">
          New Rate  for L713, NAWU Plans as of January 1st, 2026
          <router-link
          target="_blank"
            style="display:block;margin-bottom:4%"
            class="route-link"
            :to="'/document-view-details/' + base64Encode(member)"
            >Click here to view.</router-link
          >
        </p>
        <p class="new-rates" v-if="checkSolicticPlan()">
          New Rate for Solistic Plan as of June 1, 2025
          <router-link
          target="_blank"
            style="display:block;margin-bottom:4%"
            class="route-link"
            :to="{ name: 'SolisticViewCard', params: { policyId: encodePolicyId(member) } }"
            >Click here to view.</router-link
          >
        </p>

        <button
          type="button"
          class="btn univ-btn btn-secondary"
          @click="sendCardEmail"
          :disabled="isDisable"
        >
          {{ isSend ? " Sending Card" : " Send Card" }}
        </button>
      </div>
    </b-container>
  </b-modal>
</template>
<script>
import Api from "@/resource/Api";
import Helper from "@/resource/Helper";// Import Helper for objToUrlParams
import isEnrollPrimeUtil from '@/utils/isEnrollPrimeUtil';
export default {
  name: "MemberDocModal",
  data: () => ({
    targetPids: [],
    files: [],
    user: "",
    isSend: false,
    memberData: null, // Store the complete member data from API
    form: {
      policy_id: "",
      data: [],
    },
    isDisable: true,
    emailContent:{
      email_message_configuration_name: "MEMBER_CARD_CONFIGURATION",
      toAddress: [],    //member email
      ccAddress: [] ,   //agent email
      bccAddress:[],
      subject:"Important Member Benefit Information",
      attachedFiles:[],
      generalTemplateData:[],
      contentData:{
        member:"", //member name
        cards:""
      },
    }
  }),
  props: {
    member: {
      required: true,
    },
  },
  methods: {
    closeModal() {
      this.files = [];
      this.user = "";
      this.memberData = null;
      this.form = {
        policy_id: "",
        data: [],
      };
      this.$emit("onCloseModal");
      this.$bvModal.hide("memberDocModal");
    },
    
    // Method to fetch member data using the new API
    async getMemberData(policyId) {
      try {
        const filters = { policy_id: policyId };
        const filterUrl = Helper.objToUrlParams(filters);
        const url = `${this.$endpoint.GET_MEMBERS}?${filterUrl}`;
        
        const response = await Api.get(url);
        
        // Assuming the API returns records array and we need the first match
        if (response.data.records && response.data.records.length > 0) {
          this.memberData = response.data.records[0];
        }
      } catch (error) {
        console.error('Error fetching member data:', error);
        this.$notify("Failed to fetch member data", "error");
      }
    },
    
    // Method to check Solictic Plan conditions
    checkSolicticPlan() {
      if (!this.memberData) return false;
      
      // Check if cid is 11
      if (this.memberData.cid !== 11) return false;
      
      // Check if any plan_id in plan_details is greater than 1896
      const hasValidPlan = this.memberData.plan_details?.some(plan => 
        plan.plan_status === "ACTIVE" && plan.plan_id > 1896
      );
      
      return hasValidPlan;
    },

    sendCardEmail() {
      const url = `v2/send-card-email`;
      this.isSend = true;
      let loader = this.$loading.show({
        container: this.$refs.memberDocContainer,
      });
      Api.post(url, this.form)
        .then((res) => {
          this.$notify(res.data.message);
          this.closeModal();
        })
        .catch((err) => {
          this.$notify(err.response.data.message, "error");
        })
        .finally(() => {
          this.isSend = false;
          loader.hide();
        });
    },
    
    async getData() {
      const url = `v2/get-client-card-docs/${this.member.policy_id}`;
      let loader = this.$loading.show({
        container: this.$refs.memberDocContainer,
      });
      
      try {
        // Fetch both client card docs and member data
        const [cardDocsResponse] = await Promise.all([
          Api.get(url),
          this.getMemberData(this.member.policy_id)
        ]);
        
        let data = cardDocsResponse.data.data;
        this.files = data.files;
        this.user = data.user_details;
        this.form.policy_id = this.member ? this.member.policy_id : "";
      } catch (err) {
        this.$notify(err.response?.data?.message || "Error fetching data", "error");
      } finally {
        loader.hide();
      }
    },
    
    encodePolicyId(member) {
      let policy_id = member?.policy_id;
      if (!policy_id) {
        console.error('Invalid policy_id for Base64 encoding');
        return '';
      }
      try {
        return btoa(policy_id);
      } catch (error) {
        console.error('Base64 encoding failed:', error);
        return '';
      }
    },
    
    base64Encode(member) {
      let user_id = member?.user_id;
      return btoa(user_id);
    },

    fetchTargetPids() {
      const url = `v2/get-renewal-pids`;
      Api.get(url)
          .then((res) => {
              this.targetPids = res.data.targetPids.map(Number); // Convert PIDs to numbers
          })
          .catch((err) => {
              this.$notify(err.response?.data?.message || "Failed to fetch target PIDs", "error"); // Handle errors
          })
    },

    checkPlan() {
      let status = false

      // Check if any plan_id in plan_details matches a targetPid
      this.member?.plan_details?.forEach((plan) => {
          if (plan.plan_status === "ACTIVE" && this.targetPids.includes(plan.plan_id)) {
              status = true;
          }
      });

      return status;
    },

     getContentData(){
      let postData = {...this.emailContent};
      this.form.data.forEach((file)=>{
          postData.contentData.cards += `<a href="${file.url}" target="_blank" style="margin-top: 10px; margin-left: 5px;">${file.filename}</a>`;
          postData.contentData.cards += '<br>';
      })
      postData.toAddress = [this.member.user_email];
      postData.contentData.member = this.member.first_name + ' ' + this.member.last_name;
      return postData
    },
    // sendCard(){
    //   const url = this.$endpoint.API_MESSAGE_CENTER + `v1/send-email-with-content-data`;
    //   let contentData = this.getContentData();
    //   this.isSend = true;
    //   let loader = this.$loading.show({
    //     container: this.$refs.memberDocContainer,
    //   });
    //   axios.post(url, contentData)
    //     .then((res) => {
    //       this.$notify(res.data.message);
    //       this.closeModal();
    //     })
    //     .catch((err) => {
    //       this.$notify(err.response.data.message, "error");
    //     })
    //     .finally(() => {
    //       this.isSend = false;
    //       loader.hide();
    //     });
    // }
  },
  mounted() {
      this.fetchTargetPids(); // Fetch PIDs when the component is loaded
    },
  computed: {
    isEnrollPrime() {
      return isEnrollPrimeUtil.isEnrollPrime();
    },
    filteredFiles() {
      return this.isEnrollPrime?this.files.filter(file => file.filename !== 'Change/Termination Form'):this.files;
    }
  },
  watch: {
    // member: function (value) {
    //   if (value) {
    //     this.getData();
    //   }
    // },
    form: {
      handler: function(value) {
        if (value.policy_id && value.data.length > 0) {
          this.isDisable = false;
        } else {
          this.isDisable = true;
        }
      },
      deep: true,
    },
  },
};
</script>

